var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("login-form-modal", {
        model: {
          value: _vm.signInVisible,
          callback: function($$v) {
            _vm.signInVisible = $$v
          },
          expression: "signInVisible"
        }
      }),
      _vm._v(" "),
      _c(
        "b-navbar",
        { staticClass: "navbar", attrs: { toggleable: "lg" } },
        [
          _c("b-navbar-brand", { attrs: { href: "/" } }, [
            _c("img", {
              staticClass: "navbar-brand-img",
              attrs: { src: _vm.getLogo }
            })
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "nav-collapse", "is-nav": "" } },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    {
                      staticClass: "my-auto",
                      on: {
                        click: function($event) {
                          return _vm.$helpers.goToSection("block-patients")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("unipromel.patients")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticClass: "my-auto",
                      attrs: { href: "https://unipromel.es" }
                    },
                    [_vm._v("Unipromel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticStyle: { display: "contents" } },
                    [
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { blue: "", outline: "" },
                              on: {
                                click: function() {
                                  _vm.signUpVisible = true
                                }
                              }
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.$t("sign-up")))])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-nav-item",
                        [
                          _c(
                            "base-button",
                            {
                              attrs: { blue: "" },
                              on: {
                                click: function() {
                                  _vm.signInVisible = true
                                }
                              }
                            },
                            [
                              _c("span", [_vm._v(_vm._s(_vm.$t("log-in")))]),
                              _vm._v(" "),
                              _c("base-icon", {
                                staticClass: "ml-2",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                  color: _vm.$uiHelpers.isMobile
                                    ? _vm.BLUE_UNIPROMEL_COLOUR
                                    : "white"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "landing-cnt row" }, [
        _c("div", { staticClass: "bg-image" }),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 d-xl-none d-lg-flex main-block-xs" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-block-ctn col-xl-6 col-12 d-flex my-auto" },
          [
            _c(
              "div",
              { staticClass: "text-ctn my-auto" },
              [
                _c("h3", [_vm._v(_vm._s(_vm.$t("unipromel.title")))]),
                _vm._v(" "),
                _c("h1", {
                  domProps: { innerHTML: _vm._s(_vm.$t("unipromel.subtitle")) }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "mt-2 mt-md-4" }, [
                  _vm._v(_vm._s(_vm.$t("unipromel.paragraph")))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-cnt mt-5" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "btn-landing-pat mt-4 mt-md-0 mb-4",
                        attrs: { white: "", shadow: "" },
                        on: { click: _vm.openPrivateAppointments }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("unipromel.private-appointments")) +
                            " (*)"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "base-button",
                      {
                        staticClass: "btn-landing-pat mt-4 mt-md-0 mb-4",
                        attrs: { gray: "", outline: "" },
                        on: { click: _vm.openInsuranceAppointment }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("unipromel.insurance-appointments"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-4" }, [
                      _c(
                        "span",
                        {
                          staticClass: "xs-text text-primary",
                          staticStyle: {
                            "font-size": "0.85rem",
                            cursor: "pointer"
                          }
                        },
                        [
                          _vm._v(
                            "*" + _vm._s(_vm.$t("unipromel.more-information"))
                          )
                        ]
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.searchVisible
                  ? _c("landing-search-selectors", {
                      attrs: {
                        showInsurances: _vm.showInsurances,
                        services: _vm.getAvailableServices
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "learn-more",
            on: {
              click: function($event) {
                return _vm.$helpers.goToSection("become-partner")
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(_vm.$t("unipromel.learn-more")))])]
        )
      ]),
      _vm._v(" "),
      _c("neu-cards-slider2", {
        attrs: {
          cards: _vm.cards,
          blackTitle: _vm.$t("unipromel.block-2.blackTitle"),
          title: _vm.$t("unipromel.block-2.title"),
          iconsColor: _vm.BLUE_UNIPROMEL_COLOUR
        }
      }),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "section-invert reverse-sm",
          attrs: { id: "block-patients" }
        },
        [
          _c(
            "b-col",
            {
              staticClass: "content my-auto",
              staticStyle: { "text-align": "center" },
              attrs: { md: "12", lg: "6" }
            },
            [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("unipromel.block-patients.title")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "subtitle" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "subtitle-list subtitle-list-large mt-sm-5"
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticStyle: { "margin-bottom": "5%" },
                              attrs: { cols: "12" }
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "1.35rem" } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "unipromel.block-patients.subtitle"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "btn-end",
                      attrs: { white: "", outline: "" },
                      on: {
                        click: function() {
                          _vm.signUpVisible = true
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("unipromel.block-patients.access-btn"))
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "py-sm-0", attrs: { md: "12", lg: "6" } },
            [_c("div", { staticClass: "col-bg ml-lg-auto" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "section py-lg-5 py-0 my-lg-5 my-0 reverse-sm",
          attrs: { id: "become-partner" }
        },
        [
          _c(
            "b-col",
            { staticClass: "my-auto content", attrs: { md: "12", lg: "6" } },
            [
              _c("h3", [_vm._v(_vm._s(_vm.$t("unipromel.medics-together")))]),
              _vm._v(" "),
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("unipromel.free-professionals")))
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "mt-5 w-75",
                  staticStyle: { "font-size": "1.35rem" }
                },
                [_vm._v(_vm._s(_vm.$t("unipromel.text")))]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "mt-5",
                  attrs: {
                    href: "https://unipromel.es/asociarse/",
                    outline: "",
                    shadow: ""
                  }
                },
                [_vm._v(_vm._s(_vm.$t("unipromel.become-partner")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "py-5 py-lg-5", attrs: { md: "12", lg: "6" } },
            [_c("div", { staticClass: "col-bg ml-lg-auto" })]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42264c84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42264c84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/unipromel/Unipromel.vue
// module id = 4393
// module chunks = 43